const _jsxFileName = "C:\\Users\\MartinStein\\Documents\\Development\\KOMMUTER\\ride-sharing-app\\app\\js\\ride-sharing-app\\components\\RideOfferOverview.tsx";import { PageHeader } from "@ant-design/pro-layout";
import { useTranslation, useUrlParam } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Button, Dropdown, List, Menu, Modal, Switch, message } from "antd";
import Parse from "parse";
import { useParseQuery } from "parse-hooks";
import React from "react";
import { FormatWeekdays, ListContainer, Offer } from "..";

const containerStyle = {
  // padding: 24,
};

const createButtonStyle = {
  float: "right",
};

export function RideOfferOverview({}) {
  const t = useTranslation();
  const [, setCreateView] = useUrlParam("create", false, "json");

  const query = React.useMemo(
    () =>
      new Parse.Query(Offer)
        .include("route")
        // this is valid syntax for includes
        // which is not supported by typescript
        // @ts-ignore
        .include("route.start")
        // @ts-ignore
        .include("route.end")
        .equalTo("user", Parse.User.current()),
    []
  );

  const { result, loading, reload } = useParseQuery(query);

  React.useEffect(() => {
    if (!loading && result.length === 0) {
      setCreateView(true);
    }
  }, [result, loading]);

  return (
    React.createElement(React.Fragment, null
      , React.createElement(PageHeader, {
        title: t("rs:offer.list.title"),
        extra: 
          React.createElement(Button, {
            type: "primary",
            shape: "circle",
            style: createButtonStyle,
            icon: React.createElement(Icon, { icon: "ai:plus", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}} ),
            title: t("rs:offer.create.action"),
            onClick: () => {
              setCreateView(true);
            }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
          )
        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
      )

      , React.createElement(ListContainer, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
        , React.createElement(List, {
          loading: loading,
          dataSource: result,
          renderItem: (item) => {
            const onSwitch = () => {
              const nextValue = !item.get("active");

              item.set("active", nextValue);
              item.save().then(
                (ok) => {
                  if (nextValue) {
                    message.success(t("rs:offer.toggle.success_active"));
                  } else {
                    message.success(t("rs:offer.toggle.success_inactive"));
                  }

                  reload();
                },
                (error) => {
                  message.error(t("rs:offer.toggle.error"));
                }
              );
            };

            const onDelete = () => {
              Modal.confirm({
                title: t("rs:offer.delete.confirm_title"),
                content: t("rs:offer.delete.confirm_content"),
                okText: t("rs:offer.delete.ok"),
                okType: "danger",
                onOk: () => {
                  item.destroy().then(
                    (ok) => {
                      message.success(t("rs:offer.delete.success"));
                      reload();
                    },
                    (error) => {
                      console.error(error);
                      message.success(t("rs:offer.delete.error"));
                    }
                  );
                },
              });
            };

            const menu = (
              React.createElement(Menu, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}
                , React.createElement(Menu.Item, { key: "toggle", onClick: onSwitch, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
                  /* <Icon type="check" /> */
                  , React.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}, t("rs:offer.toggle.action"))
                  , React.createElement('div', { style: { paddingTop: 10 }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
                    , React.createElement(Switch, {
                      checked: item.get("active"),
                      style: { margin: "0 auto", display: "block" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
                    )
                  )
                )
                , React.createElement(Menu.Divider, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 120}} )
                , React.createElement(Menu.Item, { key: "delete", onClick: onDelete, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
                  , React.createElement(Icon, { icon: "ai:delete", __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}} )
                  , React.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}, t("rs:offer.delete.action"))
                )
                /* <Menu.Item key="edit" disabled>
                  <Icon icon="ai:edit" />
                  <span>{t("rs:offer.edit.action")}</span>
                </Menu.Item> */
              )
            );

            return (
              React.createElement(List.Item, {
                extra: 
                  React.createElement(Dropdown, {
                    overlay: menu,
                    trigger: ["click"],
                    children: 
                      React.createElement(Button, {
                        type: "default",
                        shape: "circle",
                        icon: React.createElement(Icon, { icon: "ai:more", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}
                      )
                    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}
                  )
                , __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}

                , React.createElement(List.Item.Meta, {
                  title: `${
                    !item.get("active") ? t("rs:offer.list.draft") + " " : ""
                  }${
                    item.get("route").get("start").get("title") ||
                    item.get("route").get("start").get("description")
                  } → ${
                    item.get("route").get("end").get("title") ||
                    item.get("route").get("end").get("description")
                  }`,
                  description: 
                    React.createElement(React.Fragment, null
                      , React.createElement(FormatWeekdays, { days: item.get("weekdays"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}} )
                      , React.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}, " @ "  , item.get("time"))
                    )
                  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
                )
              )
            );
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
        )
      )
      , React.createElement('div', { style: { textAlign: "center", padding: 24 }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}
        , React.createElement(Button, {
          type: "primary",
          size: "large",
          children: t("rs:offer.create.action"),
          onClick: () => {
            setCreateView(true);
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}
        )
      )
    )
  );
}
